import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { EndSessionRequest } from '@azure/msal-browser';
import { Idle } from '@ng-idle/core';
import { AppConstants } from '../constants/constants';

@Injectable({
  providedIn: 'root'
})
export class SessionExpiryGuard implements CanActivate {

  constructor(
    private idle: Idle,
    private authService: MsalService) {

  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean {
      
      const ngIdleExpiry = localStorage.getItem(AppConstants.NG2IDLE_EXPIRY);

      if(!ngIdleExpiry)
        return true;

      if(this.isSessionExpired(ngIdleExpiry)) {
        this.idle.stop();
        this.idle.clearInterrupts();
        sessionStorage.clear();
        localStorage.clear();
        
        this.processLogoutRedirectUser();
        return false;
      }

      return true;
  }
  
  private isSessionExpired(expirydDate: string): boolean {
    const currentDate = new Date();
    return currentDate.getTime() > +expirydDate;
  }

  private processLogoutRedirectUser() {
    const request: EndSessionRequest = {
      postLogoutRedirectUri: AppConstants.WELCOME_PAGE
    };

    this.authService.logoutRedirect(request);
  } 
  
}
